/*global google*/
import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useState, useEffect, useCallback, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MaterialReactTable from "material-react-table";
import {
  faArrowLeft,
  faEye,
  faImage,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
// import "../../assets/styles/FarmerDetailView.css";
import AdminHeaderNew from "./Common/AdminHeader";
import AdminSideBarNew from "./Common/AdminSideBar";
import AdminFooterNew from "./Common/AdminFooter";

const containerStyle = {
  width: "100%",
  height: "50vh",
};

const center = {
  lat: 28.641832439372656,
  lng: 77.22480777651072,
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

function CropDetailView() {
  const navigate = useNavigate();
  let { state } = useLocation();
  // const [cropSurveyData, setCropSurveyData] = useState([]);
  const [cropSurveyData, setCropSurveyData] = useState({
    surveyImageList: []
  });
  
  
  const [activeImage, setActiveImage] = useState();
  
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    // googleMapsApiKey: "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE", // prod
    googleMapsApiKey: "AIzaSyD4X4kzlpReymgcXUXGh0Q3TalmxJmasM0", // local
  });
  let imageSrc = [];

  const [map, setMap] = useState(null);
  useEffect(() => {
    console.log("state !!!!",state);
    if (state) {

    if (sessionStorage.getItem("schemeCodeModel") === "12")
      {
      
        fetchDetailedDataShow(state.farmerCode.surveyCode)
      }
      else
      {
        setCropSurveyData(state.farmerCode);
      }
    }
  }, []);

  
 

  async function fetchDetailedDataShow (value) {
    console.log("@@@value", value)

    let result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetails`, {
      
    "CropSurveyCode" : value,
    "CreatedBy":sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
    "UperLevelUserCode":sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
    "PageNumber":1
    })
    //setIsFetching(false);
    console.log("@@@cccc", result.data.dataContent[0], cropSurveyData)
    state = result.data.dataContent[0]
    console.log("@@@state", state)
    setCropSurveyData(result.data.dataContent[0])
    console.log("@@@", result.data.dataContent[0], cropSurveyData)
  }



  const onLoad = React.useCallback(function callback(map) {
   
    async function secondFunction1() {
     
     
      let mylocalvalue = state.farmerCode.surveyPolygonList;
      console.log("mylocalvalue",mylocalvalue);
      var myFinalArray = [];
      var myInfoWindow = [];
      var myPolygon;
      var myPolygon = [];
      var myMarker = [];
      var infowindow = [];
      // var CropSurveyCode = []
      for (let i = 0; i < mylocalvalue.length; i++) {
        // CropSurveyCode.push(JSON.parse(mylocalvalue[i].surveyNo))
        myPolygon[i] = "myPolygon" + [i];
        myFinalArray.push(JSON.parse(mylocalvalue[i].polygonShape));
        console.log("myFinalArray", myFinalArray);
        myPolygon[i] = new window.google.maps.Polygon({
          paths: myFinalArray,
          strokeColor: "#FF0000",
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.1,
          content: "Survey Code ",
        });

        infowindow[i] = new google.maps.InfoWindow({
          // content: "<strong>Scheme : </strong>" + mylocalvalue[i].schemeName
          content: `<div id="infoContent"> <h2>Hello</h2></div>`,
        });

        google.maps.event.addListener(myPolygon[i], "mouseover", function () {
          //  document.getElementsByClassName("gm-style-iw").nextElementSibling.style.display = "none"
          infowindow[i].setContent(this.content);
          // infowindow[i].setPosition(event.latLng);
          infowindow[i].open(map);
        });

        google.maps.event.addListener(myPolygon[i], "mouseout", function () {
          infowindow[i].close();
        });

        google.maps.Polygon.prototype.my_getBounds = function () {
          var bounds = new google.maps.LatLngBounds();
          myPolygon[i].getPath().forEach(function (element, index) {
            bounds.extend(element);
          });
          return bounds;
        };

        myPolygon[i].setMap(map);
        let newCenter = myPolygon[i].my_getBounds().getCenter();
        map.setCenter(newCenter);

        myPolygon[i].setMap(map);
        // myInfoWindow[i] = new google.maps.InfoWindow;
        // myPolygon[i].addListener('mouseover', function (event) {
        //     myPolygon[i].setEditable(!myPolygon[i].getEditable());
        //     myInfoWindow[i].setContent(this.content);
        //     myInfoWindow[i].setPosition(event.latLng);
        //     myInfoWindow[i].open(map);
        // });
        // myPolygon[i].addListener('mouseout', function (event) {
        //     myInfoWindow[i].close();
        // });
        myFinalArray = [];
        // CropSurveyCode = []

        myMarker[i] = new google.maps.Marker({
          position: myPolygon[i].my_getBounds().getCenter(),
          map: map,
          title: "Click to zoom",
        });

        myMarker[i].addListener("click", () => {
          map.panTo(myMarker[i].getPosition());
          map.setZoom(18);
        });
      }
    }
    secondFunction1();
  }, []);



  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  function removed() {
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "none";
  }

  function handleActiveClick(value) {
    setActiveImage(value);
    console.log("value@@@@@", value);
    let innerhtml = ` <img src=${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE +
        "/api/common/GetAttachbyURL?imageURL=" +
        cropSurveyData.surveyImageList[value].attPath
        : process.env.REACT_APP_PRO_MODE +
        "/api/common/GetAttachbyURL?imageURL=" +
        cropSurveyData.surveyImageList[value].attPath
      } alt="farmer Image" className="img-fluid w-100 h-50" />`;
    document.getElementById("modalBody").innerHTML = innerhtml;
  }

  return isLoaded ? (
    <>
      <AdminHeaderNew />
      <AdminSideBarNew />
      <main id="main" className="main">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Survey Details</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Survey</li>
              <li className="breadcrumb-item active">Survey Details </li>
            </ol>
          </nav>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => navigate("/newadminpanel/farmer")}
          >
            <i>
              <FontAwesomeIcon icon={faArrowLeft} />
            </i>{" "}
            Back
          </button>
        </div>
        <section className="section">
          <div className="row">
            <div className="col-lg-12 dashboard">
              <div className="card">

                {cropSurveyData && (
                  <div className="card-body p-5 pt-2">
                    <div className="row cropview">
                      <h5 className="formgrouping">Polygon Details</h5>
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={18}
                        onLoad={onLoad}
                        onUnmount={onUnmount}
                        mapTypeId="satellite"
                      ></GoogleMap>
                    </div>
                    <div className="row cropview">
                    <h5 className="formgrouping">Survey Details</h5>
                    <div className="row surveydetailsbg">
                      <div className="col -3">
                          <h6>Scheme Name</h6>
                          <p>
                            {cropSurveyData.schemeName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Survey Code</h6>
                          <p>
                            {cropSurveyData.surveyCode}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Current Year</h6>
                          <p>
                            {cropSurveyData.currentyear}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Sowing Date </h6>
                          <p>
                          {cropSurveyData.showingDate?(formatDate(cropSurveyData.showingDate)):("")}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Survey Date</h6>
                          <p>
                          {cropSurveyData.createdOnByUC?(formatDate(cropSurveyData.createdOnByUC)):("")}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Harvesting Date </h6>
                          <p>
                          
                            {cropSurveyData.harvestingDate?(formatDate(cropSurveyData.showingDate)):("")}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Polygon Area</h6>
                          <p>
                            {cropSurveyData.polygonArea}
                          </p>
                        </div>
                       
                        <div className="col-md-3">
                          <h6>Season</h6>
                          <p>
                            {cropSurveyData.seasonName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Minor Crop Category</h6>
                          <p>
                            {cropSurveyData.minorCropCategoryName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Crop Category</h6>
                          <p>
                            {cropSurveyData.cropCategoryName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Crop Name</h6>
                          <p>
                            {cropSurveyData.cropName}
                          </p>
                        </div>
                        {sessionStorage.getItem("schemeCodeModel") === "12"?( 
                          <div className="col-md-3">
                          <h6>Crop Condition</h6>
                          <p>
                            {cropSurveyData.cropConditionName}
                          </p>
                        </div>
                      ):(<></>)
                      }

              {sessionStorage.getItem("schemeCodeModel") === "12"?( 
                                        <div className="col-md-3">
                                        <h6>Crop Stage</h6>
                                        <p>
                                          {cropSurveyData.cropStageName}
                                        </p>
                                      </div>
                                    ):(<></>)
                                    }
                       
                       
                        <div className="col-md-3">
                          <h6>Crop Type</h6>
                          <p>
                            {cropSurveyData.cropingTypeName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Minor Crop Category</h6>
                          <p>
                            {cropSurveyData.minorCropCategoryName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Minor Crop</h6>
                          <p>
                            {cropSurveyData.minorCropName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Major Crop Ratio</h6>
                          <p>
                            {cropSurveyData.ratioofmajorcrop}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>State</h6>
                          <p>
                            {cropSurveyData.stateName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>District</h6>
                          <p>
                            {cropSurveyData.districtName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Sub District</h6>
                          <p>
                            {cropSurveyData.subDistrictName}
                          </p>
                        </div>
                        <div className="col-md-3">
                          <h6>Village</h6>
                          <p>
                            {cropSurveyData.villageName}
                          </p>
                        </div>
                        </div>

                        </div>
                    <div className="row cropview">
                      <h5 className="formgrouping">Image Details</h5>
                      {cropSurveyData && cropSurveyData.surveyImageList && cropSurveyData.surveyImageList.length === 0 ? null : (
                      cropSurveyData?.surveyImageList?.map((item, index) => {
                            return (
                              <>
                                <div className="col-md-2">
                                  <img
                                    src={
                                      process.env.NODE_ENV === "development"
                                        ? process.env.REACT_APP_DEV_MODE +
                                        "/api/common/GetAttachbyURL?imageURL=" +
                                        item.attPath
                                        : process.env.REACT_APP_PRO_MODE +
                                        "/api/common/GetAttachbyURL?imageURL=" +
                                        item.attPath
                                    }
                                    alt="farmer Image"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdrop"
                                    className="img-fluid imgdetials"
                                    id="imgFarmer"
                                    onClick={() => handleActiveClick(index)}
                                  />
                                </div>
                                <div className="col-md-4">
                                <div className="row imgdetialsbg">
                                  <div className="col-md-6">
                                    <h6>Latitude</h6>
                                    <p>{item.surveyorLat}</p>
                                  </div>
                                  <div className="col-md-6">
                                    <h6>Longitude</h6>
                                    <p>{item.surveyorLong}</p>
                                  </div>
                                </div> </div>
                              </>
                            );
                          }
                        )
                      )}
                     
                    </div>
                    {sessionStorage.getItem("schemeCodeModel") === "13"?(  <div className="row cropview">
                      <h5 className="formgrouping">Stage Details</h5>
                      </div>):(<></>)}
                  


                  </div>
                )}

              </div>

            </div>

          </div>

        </section>
      </main>
      <AdminFooterNew />

      <div id="mpopupBox" className="modal">
        <div className="modal-content">
          <div className="modal-header">
            <h2>View Details</h2>
            <button type="button" className="btn-close" onClick={removed}>
              X
            </button>
          </div>
          <div className="madal-body" id="modal-content"></div>
          <div className="modal-footer"></div>
        </div>
      </div>

      {cropSurveyData && console.log("!!cropSurveyData", cropSurveyData)}
      {cropSurveyData.length !== 0 ? cropSurveyData.surveyImageList.length === 0 ? (
        <></>
      ) : (
        <div
          class="modal fade "
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">
                  Image{" "}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  X
                </button>
              </div>
              <div class="modal-body" id="modalBody"></div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : ""}
    </>
  ) : (
    <></>
  );
}

export default React.memo(CropDetailView);
